<template>
  <div>
    <div class="footer">
      <div class="con">
        <div class="info">
          <div class="tel">
            <p>TEL：{{seotitle.site_phone1}} {{seotitle.site_phone2}}</p>
            <p>EMAIL：{{seotitle.site_email}} Add：{{seotitle.site_address}}</p>
          </div>
          <a
            class="copyright"
            href="http://www.beian.miit.gov.cn/state/outPortal/loginPortal.action"
          >COPYRIGHT © 2019 {{seotitle.seo_title}}教育 ALL RIGHTS RESERVED. 备案号：{{seotitle.site_beian}}</a>
        </div>
        <div class="weixin">
          <i></i>
          <p>微信公众号</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilFile from "@/ace/ace.js";
export default {
  data() {
    return {
      seotitle:'',
    };
  },
  methods: {
    titlefunc() {
      this.$axios({
        method: "post",
        url: `/api/home.config`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let data = JSON.parse(utilFile.decrypt(res.data.data));
        this.seotitle = data;
      });
    }
  },
  mounted() {
    this.titlefunc();
  }
};
</script>

<style scoped>
.footer {
  height: 140px;
  background-color: #1c1f21;
  width: 100%;
  clear: both;
  /* position: fixed;
  bottom: 0;
  left: 0; */
}
.footer .con {
  width: 1200px;
  margin: 0 auto;
  padding-top: 25px;
  position: relative;
}

.footer .con .info {
  width: 80%;
}

.footer .con .info p {
  line-height: 2em;
  font-size: 14px;
  color: #c3c5cc;
  text-align: left;
}

.footer .con .info .copyright {
  display: block;
  line-height: 2em;
  font-size: 14px;
  color: #69797f;
  text-align: left;
}

.footer .con .weixin {
  position: absolute;
  right: 30px;
  top: 40px;
  font-size: 14px;
  color: #686d70;
  line-height: 2em;
}

.footer .con .weixin p {
  margin-top: 15px;
}

.footer .con .weixin i {
  display: block;
  width: 34px;
  height: 34px;
  margin: 0 auto;
  background-image: url(http://web.wit100.net/yunmipcimg/weixin.png);
}
</style>